<template>
  <div class="vap-page">
    <Loading
      :active.sync="isLoading"
      :is-full-page="true"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div class="vap-page-header">
      <h1> External View </h1>
      <div class="btns-container">
        <VasionButton
          id="approved-destination-button"
          :classProp="'primary'"
          :isDisabled="!isDirty"
          @vasionButtonClicked="resetSettings"
        >
          Reset Settings
        </VasionButton>
        <VasionButton
          id="approved-destination-button"
          class="last-btn"
          :classProp="'primary'"
          :isDisabled="!isDirty"
          @vasionButtonClicked="saveSettings"
        >
          Save Settings
        </VasionButton>
      </div>
    </div>
    <div class="vap-page-content">
      <div class="vasion-flex-row">
        <VasionInput
          id="company-logo"
          v-model="headerImageFileName"
          class="row-field browse-input"
          title="COMPANY LOGO"
          inputType="top-white"
          name="company-logo"
          placeholder="Select File..."
          :isDisabled="true"
          :width="'306'"
        />
        <VasionButton
          id="approved-destination-button"
          class="browse-button"
          :classProp="'primary'"
          @vasionButtonClicked="showUploadDialog = !showUploadDialog"
        >
          Browse
        </VasionButton>
      </div>
      <div :key="previewKey" class="preview-box" :style="{ backgroundColor: colors.hex }">
        <img v-if="localheaderImageBase64.length" style="height: 115px;" :src="localheaderImageBase64">
      </div>
      <div class="logo-not-appearing">
        Logo not appearing? Change the sidebar color to preview the logo on different backgrounds.
      </div>
      <div v-click-outside="() => showColorPicker = false">
        <chrome-picker v-show="showColorPicker" v-model="colors" class="color-picker" />
      </div>
      <div class="vasion-flex-row">
        <VasionInput
          id="navigation-color"
          v-model="colors.hex"
          class="row-field browse-input"
          title="NAVIGATION COLOR"
          inputType="top-white"
          name="navigation-color"
          placeholder="Choose Color..."
          :isDisabled="true"
          :width="'287'"
        />
        <VasionButton
          id="approved-destination-button"
          class="browse-button"
          :classProp="'primary'"
          @vasionButtonClicked.stop.prevent="showColorPicker = !showColorPicker"
        >
          Pick Color
        </VasionButton>
      </div>
    </div>
    <VasionFileUploadDialog
      :acceptedFileTypes="['image/jpeg', 'image/png', 'image/bmp']"
      :serverOptions="serverOptions"
      :show.sync="showUploadDialog"
    />

    <VasionSnackbar
      id="upload-failure"
      :showSnackbarBool.sync="showSnackbarBool"
      :snackbarImage="snackbarImage"
      :snackbarSubTitle="snackbarSubTitle"
      :snackbarTitle="snackbarTitle"
    />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { Chrome } from 'vue-color'
import { toBase64 } from '@/store/helperModules/storage.module';
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  name: 'ExternalView',
  components: {
    'chrome-picker': Chrome,
    Loading,
  },
  data: function () {
    return {
      colors: { hex: '#fffff' },
      headerImageFileName: '',
      isDirty: false,
      isDocumentLoaded: false,
      isLoading: false,
      localheaderImageBase64: '',
      localSignatureString: '',
      loaderColor,
      loaderBackgroundColor,
      logoPath: '',
      previewKey: 1,
      serverOptions: { process: this.processHandler },
      showColorPicker: false,
      showSnackbarBool: false,
      showUploadDialog: false,
      snackbarImage: false,
      snackbarSubTitle: '',
      snackbarTitle: '',
    }
  },
  computed: {
    headerImageBase64() { return this.$store.state.forms.docExternalSettings.headerImageBase64 },
  },
  watch: {
    headerImageBase64(newString) { this.localheaderImageBase64 = newString },
    colors: {
      handler() {
        if (this.colors.hex !== this.$store.state.forms.docExternalSettings.hexColor) {
          this.isDirty = true
        } else {
          this.isDirty = false
        }
      },
      deep: true,
    },
  },
  async created() {
    this.isLoading = true
    await this.$store.dispatch('forms/getEFormExternalSettings')
    this.isLoading = false
    this.resetSettings()
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    processHandler: async function (fieldName, file, metadata, load, error, progress, abort) {
      try {
        this.errorText = ''
        const pngIndex = file.name.toLowerCase().indexOf('.png')
        const jpegIndex = file.name.toLowerCase().indexOf('.jpeg')
        const jpgIndex = file.name.toLowerCase().indexOf('.jpg')
        const bmpIndex = file.name.toLowerCase().indexOf('.bmp')
        if (pngIndex < 0 && jpegIndex < 0 && jpgIndex < 0 && bmpIndex < 0) {
          const errorText = 'Only .png, .jpeg / .jpg, and .bmp file types are supported.\nPlease try uploading one of those file types.'
          this.showSnackbarBool = true
          this.snackbarTitle = 'Unable to upload this file type.'
          this.snackbarSubTitle = errorText
          this.snackbarImage = false
          console.warn(errorText)
          this.errorText = errorText
        } else {
          this.localheaderImageBase64 = await toBase64(file)
          this.headerImageFileName = file.name
          this.isDocumentLoaded = true
          this.isDirty = true
        }

        progress(true, 0, 1024);
        load(file.name)
        this.fileUploaded = true
        this.showUploadDialog = false
      } catch (e) {
        console.warn(e)
      }
    },
    resetSettings() {
      this.colors = { hex: this.$store.state.forms.docExternalSettings.hexColor }
      this.localheaderImageBase64 = this.$store.state.forms.docExternalSettings.headerImageBase64
      this.headerImageFileName = this.$store.state.forms.docExternalSettings.headerImageFileName
      this.isDirty = false
    },
    async saveSettings() {
      this.isLoading = true
      const payload = {
        hexColor: this.colors.hex,
        headerImageBase64: this.localheaderImageBase64,
        headerImageFileName: this.headerImageFileName,
      }
      const res = await this.$store.dispatch('forms/saveEFormExternalSettings', payload)
      this.isLoading = false
      if (res.Value === 'True') {
        this.showSnackbarBool = true
        this.snackbarTitle = 'SUCCESS'
        this.snackbarSubTitle = 'Settings saved!'
        this.snackbarImage = true
        this.isDirty = false
      } else {
        this.showSnackbarBool = true
        this.snackbarTitle = 'ERROR'
        this.snackbarSubTitle = 'Unable to save settings!'
        this.snackbarImage = false
      }
    },
    toggleShowColorPicker() { this.showColorPicker = !this.showColorPicker },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';
  .browse-button {
    position: relative;
    top: 17px;
  }
  .color-picker {
    position: absolute;
    z-index: 23;
    top: 409px;
    left: 687px;
  }
  .ext-header-container {
    display: flex;
    justify-content: space-between;
    padding-right: 16px;
  }
  .headline-bold {
    margin: 0;
    @include Headline;
    margin-bottom: 23px;
  }
  .logo-not-appearing {
    width: 368px;
    height: 24px;
    font-family: HelveticaNeue;
    font-size: 10px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $grey-400;
    margin-bottom: 27px;
  }
  .padding-container {
    padding: 23px 0 0 16px;
  }
  .preview-box {
    border: 1px solid $grey-100;
    height: 124px;
    width: 400px;
    border-radius: 8px;
    margin: 16px 0 8px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .save-button {
    bottom: 7px;
    position: relative;
  }
</style>
